export const ORDER_STATUS_OPTIONS = [
  { name: 'ENVIADO', value: 'sent' },
  { name: 'RECIBIDO', value: 'received' },
  { name: 'DESPACHADO', value: 'dispatched' },
  { name: 'FACTURADO', value: 'billed' },
  { name: 'CANCELADO', value: 'cancelled' },
  { name: 'POR FACTURAR', value: 'tobebilled' },
  { name: 'EN CAMINO', value: 'ontheway' },
  { name: 'PARCIAL', value: 'partial' },
  { name: 'ANULADO', value: 'annulled' }
]
